/*
 * Legacy product picker (sections/pdp.liquid via snippets/pdp-options.liquid, Andrew 2026-10-24).
 * Opens with NOTHING picked (a ?variant= deep link still preselects). Options can be picked in any order: each
 * value is judged against the picks in the other groups — sold out = crossed out (still clickable, shows Sold Out),
 * no such combination = dashed (clickable; the clashing pick is cleared). Add to Cart is locked ("Select a size")
 * until every option is picked; the price reads "From $X" meanwhile.
 *
 * It sits on top of the old jQuery sm-rc widget (snippets/dup-sm-rc-widget.liquid) instead of replacing it: clicks
 * on the option buttons / radios are taken in the capture phase (the old handlers in custom.js and the theme
 * bundle never see them), and a finished selection is handed to the widget by setting its variant <select> and
 * triggering change — the widget still renders price, stock, Notify Me, gallery, ?variant= and the cart form id.
 * Selection logic: window.SBABcdPicker (assets/pdp-bcd-variant-picker.js, tested in tests/).
 */
(function () {
  'use strict';

  // Captured at parse time: the widget rewrites ?variant= on its first render (DOM ready).
  var deepLink = null;
  try { deepLink = new URLSearchParams(window.location.search).get('variant'); } catch (e) {}

  function init() {
    var P = window.SBABcdPicker, $ = window.jQuery;
    var dataEl = document.getElementById('pdp-legacy-variant-data');
    if (!P || !$ || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // Option groups in DISPLAY order (Color swatches first, as the Liquid renders them).
    var groups = Array.prototype.slice.call(document.querySelectorAll('.option__wrap[data-option-index]'));
    var keys = groups.map(function (g) { return 'option' + g.getAttribute('data-option-index'); });
    if (!groups.length || groups.some(function (g) { return !g.querySelector('[data-option-value]'); })) return;
    function valueEls(g) { return Array.prototype.slice.call(g.querySelectorAll('button[data-option-value], input[data-option-value]')); }
    var valuesByKey = {};
    groups.forEach(function (g, i) { valuesByKey[keys[i]] = valueEls(g).map(function (el) { return el.getAttribute('data-option-value'); }); });
    function nameOf(g) {
      var n = g.getAttribute('data-legacy-option-name');
      if (n) return n;
      var lbl = g.querySelector('.option__colorLabel') || g.querySelector('label');
      return lbl ? lbl.textContent.replace(/select an?|:/gi, '').trim() : 'option';
    }

    var $variant = $('[sm-rc-variant-selector]');
    var atc = document.querySelector('[sm-rc-add-to-cart]');
    var isText = atc && atc.querySelector('.is-text');
    var atcLabel = isText ? isText.textContent : '';
    var anyInStock = variants.some(function (v) { return v.available; });
    var selected = {};
    keys.forEach(function (k) { selected[k] = null; });

    var dl = deepLink && variants.filter(function (v) { return String(v.id) === String(deepLink); })[0];
    if (dl) keys.forEach(function (k) { selected[k] = dl[k]; });

    function render() {
      groups.forEach(function (g, i) {
        var key = keys[i];
        valueEls(g).forEach(function (el) {
          var val = el.getAttribute('data-option-value');
          var on = val === selected[key];
          var host = el.tagName === 'INPUT' ? el.closest('li') || el : el;
          if (el.tagName === 'INPUT') el.checked = on; else el.classList.toggle('active', on);
          var st = P.peerState(variants, selected, keys, key, val);
          if (st === 'soldout' && !anyInStock) st = 'available';
          host.classList.toggle('is-soldout', st === 'soldout');
          host.classList.toggle('is-nocombo', st === 'none');
          el.setAttribute('aria-label', nameOf(g) + ': ' + val + (st === 'soldout' ? ' (sold out)' : st === 'none' ? ' (not available in this combination)' : ''));
        });
      });
    }

    function pending() {
      var missing = null;
      for (var i = 0; i < groups.length; i++) if (selected[keys[i]] == null) { missing = groups[i]; break; }
      var name = missing ? nameOf(missing).toLowerCase() : 'option';
      if (atc) atc.disabled = true;
      if (isText) isText.textContent = 'Select ' + (/^[aeiou]/.test(name) ? 'an ' : 'a ') + name;
      $('.oos-text').hide(); $('.is-text').show(); $('.bis-trigger').removeClass('active');
      // "From <lowest price>" over the variants that fit the picks so far (in-stock ones when there are any).
      var pool = variants.filter(function (v) { return keys.every(function (k) { return selected[k] == null || v[k] === selected[k]; }); });
      var inStock = pool.filter(function (v) { return v.available; });
      if (inStock.length) pool = inStock;
      var min = null, text = '', differ = false;
      pool.forEach(function (v) {
        var n = parseFloat(String(v.price).replace(/[^0-9.]/g, ''));
        if (isNaN(n)) return;
        if (min !== null && n !== min) differ = true;
        if (min === null || n < min) { min = n; text = v.price; }
      });
      if (min !== null) $('[sm-rc-current-price]').text((differ ? 'From ' : '') + text);
      $('[sm-rc-discount-price]').text('');
      // The widget labels the color from the variant it rendered (the look variant); show only what was picked.
      var color = groups[0] && groups[0].classList.contains('option__wrap--swatches') ? selected[keys[0]] : null;
      $('[sm-rc-current-color]').text(color || '');
      try {
        var u = new URL(window.location.href);
        if (u.searchParams.has('variant')) { u.searchParams.delete('variant'); window.history.replaceState({}, '', u.toString()); }
      } catch (e) {}
    }

    function commit(v) {
      if (isText) isText.textContent = atcLabel;
      $variant.val(String(v.id)).trigger('change'); // the widget renders price / stock / gallery / URL / form id
    }

    function apply() {
      render();
      var v = P.exactVariant(variants, selected, keys);
      if (v) { commit(v); return; }
      // Partial pick: show the best-matching variant's photos (the widget switches the gallery), then re-lock.
      var look = variants.filter(function (x) {
        return x.image && keys.every(function (k) { return selected[k] == null || x[k] === selected[k]; });
      }).sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); })[0];
      if (look && keys.some(function (k) { return selected[k] != null; })) $variant.val(String(look.id)).trigger('change');
      pending();
    }

    groups.forEach(function (g, i) {
      g.addEventListener('click', function (e) {
        var el = e.target.closest('button[data-option-value], li, label, input[data-option-value]');
        if (!el || !g.contains(el)) return;
        if (el.tagName === 'LI' || el.tagName === 'LABEL') el = el.querySelector('input[data-option-value]') || (el.htmlFor && document.getElementById(el.htmlFor)) || el;
        var val = el.getAttribute && el.getAttribute('data-option-value');
        if (val == null) return;
        e.preventDefault();
        e.stopPropagation(); // capture phase: the old custom.js / bundle handlers never run
        selected[keys[i]] = val;
        selected = P.reconcile(variants, selected, keys, keys[i], valuesByKey);
        apply();
      }, true);
    });

    // Never add a fallback variant while the selection is incomplete.
    if (atc) atc.addEventListener('click', function (e) {
      if (!P.exactVariant(variants, selected, keys)) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);

    if (dl) { render(); commit(dl); }
    else { render(); pending(); }
  }

  // After the widget's and custom.js's DOM-ready handlers (they preselect the first variant; we undo that).
  if (window.jQuery) window.jQuery(function () { setTimeout(init, 0); });
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
})();
